import React, { Fragment, useEffect } from 'react';
import PropTypes from 'prop-types'

import { togglePrivacyModal, setPrivacyModal, goBack } from '../../actions/navActions';

// Redux
import { connect } from 'react-redux';

// Modals
import DefaultModal from './DefaultModal';
import ModalContainer from './ModalContainer';

// Components - imported
import { Button } from '@material-ui/core';
import AuthPage_Body from '../../pages/auth/AuthPage_Body';

// Icons - material UI
import CloseOutlinedIcon from '@material-ui/icons/CloseOutlined';
import CreateIcon from '@material-ui/icons/Create';
import MailIcon from '@material-ui/icons/Mail';
import FavoriteIcon from '@material-ui/icons/Favorite';
import LocalMallIcon from '@material-ui/icons/LocalMall';

const PrivacyModal = ({ 
    auth,
    nav: { 
        privacyModal,
        privacyModalType,
        country_code,
        continent_name,
        show_firewall,
        geo_loading
    },
    togglePrivacyModal,
    setPrivacyModal,
    goBack
 }) => {

    // --- Security Function --- 

    let isFromAfrica = false;

    if(country_code?.toLowerCase() === 'ng' || continent_name?.toLowerCase() === 'africa') {
        isFromAfrica = true;
    }

    if(privacyModal && !geo_loading && (isFromAfrica || show_firewall)) {
        setPrivacyModal(false);
        window.location.href = '/404';
    }

    // --- END: Security Function --- 

    {/* Authentication Modal - if not logged in && triggered an Action */}
    return (
        <ModalContainer show={privacyModal} onClose={togglePrivacyModal}>
            <DefaultModal>
                <div className="closeBtn__container start transparent no_header">
                    <div onClick={ togglePrivacyModal} className="closeBtn">
                        <CloseOutlinedIcon />
                    </div>
                </div>

                {/* Not Authenticated Action */}
                <div className="guest__action">
                    {/* Tried to: Interact with a restricted group */}
                        
                        {/* Modal Content */}
                        <div style={{width:'100%', margin:'32px'}}>

                            {privacyModalType === 'students only' && (
                                <Fragment>
                                    <div style={{marginBottom:'16px', textAlign: 'center'}}>
                                        {/* Modal Title */}
                                        <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                            <span>School Email Required</span>
                                        </div>
                                        {/* Modal Description */}
                                        <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                            <span>
                                                You need a verified school email to join this group.
                                            </span>
                                        </div>
                                    </div>
                                    <div style={{width: '100%', padding: '0 32px', boxSizing: 'border-box'}}>
                                        <Button 
                                            variant="outlined" 
                                            className="sidebar__tweet black"
                                            fullWidth
                                            onClick={() => window.location = '/search_schools'}
                                        >
                                            Verify School Email
                                        </Button>
                                    </div>
                                </Fragment>
                            )}

                            {/* Tried to: post without following group with priavcy set to restricted */}
                            {privacyModalType === 'restricted' && (
                                <Fragment>
                                    <div style={{marginBottom:'16px', textAlign:'center'}}>
                                        {/* Modal Title */}
                                        <div style={{marginBottom:'8px', lineHeight:'32px', fontSize:'26px', fontWeight:'800', overflowWrap:'break-word'}}>
                                            <span>You can't post yet</span>
                                        </div>
                                        {/* Modal Description */}
                                        <div style={{ color:'rgb(83, 100, 113)', fontWeight:'500', fontSize:'15px', lineHeight:'20px', overflowWrap:'break-word'}}>
                                            <span>
                                                This group is restricted. Only followers can post.
                                            </span>
                                        </div>
                                    </div>
                                    <div style={{width: '100%', padding: '0 32px', boxSizing: 'border-box'}}>
                                        <Button 
                                            variant="outlined" 
                                            className="sidebar__tweet black"
                                            fullWidth
                                            onClick={togglePrivacyModal}
                                        >
                                            Close
                                        </Button>
                                    </div>
                                </Fragment>
                            )}
                    
                        </div>
                    
                    </div>
                
            </DefaultModal>
        </ModalContainer>
    )
}

PrivacyModal.propTypes = {
    auth: PropTypes.object.isRequired,
    nav: PropTypes.object.isRequired,
    // Function to toggle the authentication modal
    togglePrivacyModal: PropTypes.func.isRequired,
    setPrivacyModal: PropTypes.func.isRequired,
    goBack: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
    auth: state.auth,
    nav: state.nav
})

export default connect(mapStateToProps, { 
    // Connecting actions to the component
    togglePrivacyModal,
    setPrivacyModal,
    goBack
})(PrivacyModal);


